// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
const config = require('../page_config.json')

Vue.config.productionTip = false

Vue.prototype.$config = config

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js